import React from 'react';
import { motion } from 'framer-motion';
import { Check, Calendar, CheckSquare, ListOrdered, Repeat, Focus, MoreHorizontal } from 'lucide-react';
import { useTranslation } from '../../../providers/TranslationProvider';

const Step1Needs = ({ data, onUpdate, isDarkMode }) => {
    const { t } = useTranslation();
    const selectedNeeds = data.needs || [];

    const needsOptions = [
        { id: 'organize', label: t('onboarding.needs.organize'), icon: Calendar },
        { id: 'remember', label: t('onboarding.needs.remember'), icon: CheckSquare },
        { id: 'prioritize', label: t('onboarding.needs.prioritize'), icon: ListOrdered },
        { id: 'routines', label: t('onboarding.needs.routines'), icon: Repeat },
        { id: 'focus', label: t('onboarding.needs.focus'), icon: Focus },
        { id: 'other', label: t('onboarding.needs.other'), icon: MoreHorizontal },
    ];

    const toggleNeed = (id) => {
        if (selectedNeeds.includes(id)) {
            onUpdate({ needs: selectedNeeds.filter(item => item !== id) });
        } else {
            onUpdate({ needs: [...selectedNeeds, id] });
        }
    };

    return (
        <div className="w-full">
            <motion.div
                className="grid grid-cols-2 gap-2.5"
                initial="hidden"
                animate="visible"
                variants={{
                    visible: { transition: { staggerChildren: 0.03 } }
                }}
            >
                {needsOptions.map((option) => {
                    const isSelected = selectedNeeds.includes(option.id);
                    const Icon = option.icon;
                    return (
                        <motion.button
                            key={option.id}
                            variants={{
                                hidden: { opacity: 0, scale: 0.95 },
                                visible: { opacity: 1, scale: 1 }
                            }}
                            whileTap={{ scale: 0.96 }}
                            onClick={() => toggleNeed(option.id)}
                            className={`w-full p-3.5 rounded-xl border flex flex-col items-center justify-center text-center gap-2 transition-all duration-200 backdrop-blur-md min-h-[100px] ${isSelected
                                ? 'border-blue-500 bg-blue-500/10'
                                : isDarkMode
                                    ? 'border-white/5 bg-white/5 hover:bg-white/10'
                                    : 'border-slate-200 bg-white/50 hover:bg-slate-50'
                                }`}
                        >
                            <div className={`p-2 rounded-lg transition-colors duration-200 ${isSelected
                                ? 'bg-blue-500 text-white'
                                : isDarkMode ? 'bg-white/5 text-slate-400' : 'bg-slate-100 text-slate-500'
                                }`}>
                                <Icon size={20} />
                            </div>
                            <span className={`text-sm font-medium leading-tight ${isSelected
                                ? 'text-blue-400'
                                : isDarkMode ? 'text-slate-300' : 'text-slate-700'
                                }`}>
                                {option.label}
                            </span>

                            {isSelected && (
                                <div className="absolute top-2 right-2">
                                    <Check size={14} className="text-blue-500" />
                                </div>
                            )}
                        </motion.button>
                    );
                })}
            </motion.div>
        </div>
    );
};

export default Step1Needs;
